import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SalesOverviewClient, ClientSalesOverviewDTO, SalesOverviewFilterDTO } from '../../../base/models/models.swagger.generated';

@Injectable({
  providedIn: 'root'
})
export class SalesOverviewService {
  constructor(private client: SalesOverviewClient) { }

  getClientSalesOverview(filters?: SalesOverviewFilterDTO, skip: number = 0, take: number = 20): Observable<ClientSalesOverviewDTO> {
    return this.client.getClientSalesOverview(filters, skip, take);
  }
}
